// HERO BANNER
if (window.innerWidth > 1024) {
    console.log("fullbleed");
document.querySelectorAll('.hcb-section .custom-container').forEach(el => {
  // 1. Extract the initial margin-left value
  const initialMarginLeft = window.getComputedStyle(el).marginLeft;

  // 2. Apply max-width: 100%
  el.style.maxWidth = '100%';

  // 3. Remove all margins
  el.style.margin = '0';

  // 4. Re-apply the captured margin-left
  el.style.marginLeft = initialMarginLeft;
});
}
// CARD GRID SLIDER:

var ncg_swiper = new Swiper('.swiper.ncg-swiper', {
    slidesPerView: 4,
    spaceBetween: 25,
    autoHeight: false,
    navigation: {
        nextEl: '.ncg-swiper .swiper-button-next',
        prevEl: '.ncg-swiper .swiper-button-prev',
    },

    pagination: {
        el: '.ncg-swiper .swiper-pagination',
    },

    autoplay: {
        delay: 3000,
        disableOnInteraction: true
    },

    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 20,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 25,
        },
    }
});

var reviews_swiper = new Swiper('.swiper.custom-reviews-swiper', {
    slidesPerView: 3,
    spaceBetween: 25,
    autoHeight: false,

    autoplay: {
        delay: 30000, // 3 seconds
        disableOnInteraction: true
    },
    breakpoints: {
        0: {
            slidesPerView: 1,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 25,
        }
    }
});

